import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import { RemoveCookie, days, user_session_id } from "./GlobalScript";

export default function Error() {
    const [msg, setMsg] = useState('ERROR');
    const location = useLocation();

    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search);
        const id = queryParameters.get("id");
        if (id) {
            if (id === 'A') {
                setMsg("The Dealer Code entered is invalid.");
            } else {
                setMsg("Invalid Credentials.  Please try again with a valid Dealer Code.");
            }
        }
        else {
            setMsg("ERROR");
        }
        RemoveCookie(days, user_session_id);
        localStorage.removeItem('shoppingcart');
        localStorage.removeItem("orderSearch");
        localStorage.removeItem("creditSearch");
    }, [location])

    return (
        <Container className="checkout-container main-container">
            <Container className="checkout-container">

                <Card className="confirmation-card mb-6 box-shadow">
                    <Card.Body>
                        <Row className="title-group confirmation-heading">
                            <Card.Title className="vertical-line heading card-main-title confirm-title" role="heading">Error</Card.Title>
                        </Row>
                        <Row className="confirm-text first-confirm">
                            <p className="confirmation-text" aria-level="1" role="heading">{msg}</p>
                        </Row>
                        <Row className="confirm-button">
                            <Button variant="primary" className="confirm-complete" onClick={() => window.history.back()}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                BACK
                            </Button>
                        </Row>
                    </Card.Body>
                </Card>

            </Container>
        </Container>
    )
}